import type { NormalizedSDKConfig } from '@/lib/embed-contracts/sdk-config'
import { resolveEmbedRoutePath } from '@/lib/embed-contracts/route-resolver'

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '')
}

function ensureLeadingSlash(value: string) {
  if (!value) return ''
  return value.startsWith('/') ? value : `/${value}`
}

export function resolveIframeUrl(config: Pick<NormalizedSDKConfig, 'baseUrl' | 'pathPrefix' | 'route'>) {
  const baseUrl = trimTrailingSlash(config.baseUrl)
  const pathPrefix = trimTrailingSlash(ensureLeadingSlash(config.pathPrefix))
  const routePath = resolveEmbedRoutePath(config.route)

  return `${baseUrl}${pathPrefix}${routePath}`
}

export const buildIframeUrl = resolveIframeUrl